'use client'

import { useEffect, useState } from 'react'
import {
  isBuildGuardEnabled,
  isStaleChunkErrorFromError,
  reloadOnceForStaleChunk,
} from '@/app/[locale]/_utils/stale-chunk'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  const [isReloadingStaleChunk, setIsReloadingStaleChunk] = useState(false)

  useEffect(() => {
    if (isBuildGuardEnabled() && isStaleChunkErrorFromError(error)) {
      setIsReloadingStaleChunk(true)
      reloadOnceForStaleChunk()
      return
    }

    if (process.env.NODE_ENV === 'production') {
      fetch('/api/errors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          error: {
            message: error.message,
            name: error.name,
            stack: error.stack,
          },
          location: window.location.href,
        }),
      }).catch(() => {})
    }

    console.error('[Global Error]:', error)
  }, [error])

  if (isReloadingStaleChunk) {
    return (
      <html>
        <body
          style={{
            margin: 0,
            padding: 0,
            fontFamily: 'system-ui, -apple-system, sans-serif',
            backgroundColor: '#f5f5f5',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '100vh',
              padding: '2rem',
              textAlign: 'center',
              color: '#666',
            }}
          >
            Updating app…
          </div>
        </body>
      </html>
    )
  }

  return (
    <html>
      <body
        style={{
          margin: 0,
          padding: 0,
          fontFamily: 'system-ui, -apple-system, sans-serif',
          backgroundColor: '#f5f5f5',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#333' }}>
            Something went wrong
          </h1>
          <p style={{ color: '#666', marginBottom: '2rem', maxWidth: '500px' }}>
            We&apos;re sorry, but something unexpected happened. Our team has
            been notified.
          </p>
          <div
            style={{
              display: 'flex',
              gap: '1rem',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            <button
              onClick={() => reset()}
              style={{
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                backgroundColor: '#0070f3',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '500',
              }}
            >
              Try again
            </button>
            <button
              onClick={() => (window.location.href = '/')}
              style={{
                padding: '0.75rem 1.5rem',
                fontSize: '1rem',
                backgroundColor: '#f0f0f0',
                color: '#333',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '500',
              }}
            >
              Go to homepage
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
